import React from "react";
import Switch from "react-switch";
import { connect } from "react-redux";
let checked = false;
class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
  }
  handleClick = (e, data) => {
    if (data == "and") {
      this.setState({ checked: false });
    } else {
      this.setState({ checked: true });
    }
    this.toggleReduxChange();
  };

  toggleReduxChange() {
    let selectedToggle = this.state.checked ? "AND" : "OR";
    let type =
      this.props.type == "Rule"
        ? "CUST_ADD_RULE_LEVEL_TOGGLE"
        : "CUST_ADD_GROUP_LEVEL_TOGGLE";
    this.props.dispatch({
      type: type,
      payload: selectedToggle,
      selectedIndex: this.props.selectedIndex,
      selectedRule: this.props.selectedRule
    });
    this.props.dispatch({ type: "CUST_Add" });
  }

  render() {
    let selectedIndex = this.props.selectedIndex;
    let selectedRule = this.props.selectedRule;
    if (
      selectedRule !== "" &&
      selectedIndex !== "no_index"
    ) {
      if (this.props.cust_ruleLeveltoggle.length > 0 && this.props.cust_ruleLeveltoggle[selectedIndex] !== undefined && this.props.cust_ruleLeveltoggle[selectedIndex][selectedRule] !== undefined) {
        checked =
          this.props.cust_ruleLeveltoggle[selectedIndex][
            selectedRule
          ] === "AND"
            ? false
            : true;
      }
      this.state = { checked: checked };
    } else if (selectedIndex !== "no_index") {
      if (this.props.cust_groupLeveltoggle.length > 0 && this.props.cust_groupLeveltoggle[0] !== undefined && this.props.cust_groupLeveltoggle[0][selectedIndex][selectedIndex] !== undefined) {
        checked =
          this.props.cust_groupLeveltoggle[0][selectedIndex] === "AND"
            ? false
            : true;
      }
      this.state = { checked: checked };
    } else {
      this.state = { checked: checked };
    }
    return (
      <React.Fragment>
        <span
          className={this.state.checked ? "andorbtn btnor" : "andorbtn btnand"}
          onClick={e => this.handleClick(e, "and")}
        >
          and
        </span>
        <span
          className={this.state.checked ? "andorbtn btnand" : " andorbtn btnor"}
          onClick={e => this.handleClick(e, "or")}
        >
          or
        </span>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  cust_count : state.cust_count,	
  cust_tillSqlSelectionArr : state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr : state.cust_afterSqlSelectionArr,
  cust_groupLeveltoggle : state.cust_groupLeveltoggle,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_queryCount: state.cust_queryCount
});

export default connect(mapStateToProps)(ToggleButton);



// WEBPACK FOOTER //
// ./src/views/Audiences/CCustomQueryBuilder/ToggleButton.jsx